import { EditIcon, DeleteIcon } from '@chakra-ui/icons';

export const columnsDataEvents = [
  {
    Header: 'Código',
    accessor: 'code',
    width: '88px',
  },
  {
    Header: 'Descripción',
    accessor: 'name',
  },
  {
    Header: '',
    accessor: 'actions',
    width: '96px',
    actions: [
      {
        label: 'Editar',
        icon: <EditIcon />,
        colorScheme: 'blue',
        type: 'edit',
      },
      {
        label: 'Eliminar',
        icon: <DeleteIcon />,
        colorScheme: 'red',
        type: 'delete',
      },
    ],
  },
];
